import React from 'react';
import './Support.css';

const Support = () => {
  return (
    <div className="support-container">

      <h1>Support for Icatalog App</h1>
      <p>We're committed to providing excellent support to all Icatalog App users.</p>

      <h2>How to Get Help</h2>
      <p>If you need assistance, reach out to our support team through the following channels:</p>
      <ul>
        <li>Email Support: support@orail.in</li>
        <li>Phone Support: 0261-3603500</li>
      </ul>

      <h2>User Guides and Tutorials</h2>
      <p>
        Explore step-by-step guides for using the icatalog App—from managing customer data and
        scanning products to generating prints, sales orders, and managing stock and designs.
      </p>

      <h2>System Status and Updates</h2>
      <p>
        Stay informed about ongoing issues, scheduled maintenance, and system updates that may
        impact app performance.
      </p>

      <h2>Support Hours</h2>
      <p>Our support team is available:</p>
      <ul>
        <li>Monday to Saturday: 9:30 AM – 6:30 PM (EST)</li>
        <li>Sunday: Closed</li>
      </ul>
      <p>For inquiries outside these hours, email us and we’ll get back to you as soon as possible.</p>

      <h2>Feedback and Suggestions</h2>
      <p>
        We value your input! Share your feedback and ideas for improving Icatalog App by emailing
        us at support@orail.in.
      </p>

    </div>
  );
};

export default Support;
